import React from "react";
import { Link } from "react-router-dom";
import { GsdHeroBlock, GsdReadableBlock } from "@/coquille-bridge";
import { usePublicCopy } from "@/i18n/karatePublicI18n.js";
import { PageSection } from "@/components/AppLayout.jsx";
import { KARATE_BRAND_TITLE, KARATE_FULL_LOGO_ASSET } from "@/components/KarateHeaderLogo.jsx";

export function HomePage() {
  const { copy } = usePublicCopy();
  const h = copy.home;
  return (
    <div className="home-page home-page--polish" data-testid="page-accueil">
      <GsdHeroBlock
        testId="home-hero"
        kicker={h.kicker}
        title={h.title}
        lead={h.lead}
        actions={
          <>
            <Link to="/devenir-membre" className="btn-primary btn-lg" data-testid="home-cta-become-member">
              {h.ctaBecomeMember}
            </Link>
            <Link to="/demande-compte" className="btn-primary-outline btn-lg" data-testid="home-cta-request-account">
              {h.ctaAccount}
            </Link>
            <Link to="/dojos" className="btn-primary-outline btn-lg" data-testid="home-cta-dojos">
              {h.ctaDojos}
            </Link>
            <Link to="/connexion" className="btn-secondary btn-lg" data-testid="home-cta-login">
              {h.ctaLogin}
            </Link>
          </>
        }
        aside={
          <div data-testid="hero-identity-panel">
            <div className="hero-panel__logo-wrap">
              <img src={KARATE_FULL_LOGO_ASSET} alt={KARATE_BRAND_TITLE} className="hero-panel__logo" />
            </div>
            <p className="hero-panel__brand">{KARATE_BRAND_TITLE}</p>
            <ul className="hero-panel__checklist">
              <li>{h.checklistCourses}</li>
              <li>{h.checklistAges}</li>
              <li>{h.checklistSensei}</li>
            </ul>
          </div>
        }
      >
        <p className="hero-message">{h.heroMessage}</p>
      </GsdHeroBlock>

      <GsdReadableBlock className="home-section home-section--wide" testId="home-section-why">
        <header className="home-section__header">
          <h2 className="home-section__title">{h.whyTitle}</h2>
        </header>
        <div className="coverage-grid coverage-grid--wide" data-testid="home-why-karate">
          {h.whyCards.map((item) => (
            <article key={item.id} className="coverage-card coverage-card--ready">
              <span className="coverage-card__icon" aria-hidden="true">
                {item.icon}
              </span>
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </article>
          ))}
        </div>
      </GsdReadableBlock>

      <GsdReadableBlock className="home-section home-section--wide" testId="home-section-audience">
        <header className="home-section__header">
          <h2 className="home-section__title">{h.audienceTitle}</h2>
          <p className="home-section__lead">{h.audienceLead}</p>
        </header>
        <div className="stat-card-grid">
          {h.audienceCards.map((item) => (
            <article key={item.id} className="stat-card stat-card--ready" data-testid={`home-audience-${item.id}`}>
              <h3 className="stat-card__title">{item.title}</h3>
              <p className="stat-card__desc">{item.desc}</p>
              <span className="stat-card__status">{item.status}</span>
            </article>
          ))}
        </div>
      </GsdReadableBlock>

      <GsdReadableBlock className="home-section home-section--wide" testId="home-section-dojos-instructors">
        <div className="home-grid home-grid--cta">
          <article className="stat-card stat-card--ready">
            <h3 className="stat-card__title">{h.dojosTitle}</h3>
            <p className="stat-card__desc">{h.dojosDesc}</p>
            <Link to="/dojos" className="btn-primary" data-testid="home-link-dojos">
              {h.dojosLink}
            </Link>
          </article>
          <article className="stat-card stat-card--ready">
            <h3 className="stat-card__title">{h.instructorsTitle}</h3>
            <p className="stat-card__desc">{h.instructorsDesc}</p>
            <Link to="/instructeurs" className="btn-primary" data-testid="home-link-instructors">
              {h.instructorsLink}
            </Link>
          </article>
        </div>
      </GsdReadableBlock>
    </div>
  );
}

export function AboutPage() {
  const { copy, isEn } = usePublicCopy();
  const a = copy.about;
  return (
    <PageSection title={a.title} subtitle={a.subtitle} testId="page-a-propos">
      <div className="prose prose--wide">
        <p>
          {isEn
            ? "This portal presents Shotokan AAMC, its dojos and martial leadership."
            : "Ce portail présente Shotokan AAMC, ses dojos et son leadership martial."}
        </p>
        <p>
          {isEn ? (
            <>
              Technical direction is led by the <strong>Hanshi</strong>; each dojo is represented by a responsible{" "}
              <strong>Sensei</strong>.
            </>
          ) : (
            <>
              La direction technique est assurée par le <strong>Hanshi</strong> ; chaque dojo est représenté par un{" "}
              <strong>Sensei</strong> responsable.
            </>
          )}
        </p>
      </div>
    </PageSection>
  );
}
